<template>
    <span> {{ resultId }} </span>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'ZeroPadding',
})
export default class ZeroPadding extends Vue {
    @Prop({ default: 0 }) id: number;

    zero: string = '00000';

    get resultId(): string {
        return this.id < 100000 ? (this.zero + this.id.toString()).slice(-5) : this.id.toString();
    }
}
</script>
